export const LanguageDateFormat: { [key: string]: string } = {
    "en": "MM/DD/YYYY",
    "ja": "YYYY/MM/DD",
    "ko": "YYYY/MM/DD",
    "es": "DD/MM/YYYY",
    "el": "DD/MM/YYYY",
    "bs": "DD/MM/YYYY",
    "de": "DD/MM/YYYY",
}